(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-button-floating"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('[data-floating-button]');
  if (!btn) return;

  // Abstand vor Seitenende, ab dem der Button verschwindet (px)
  var hideBeforeBottom = 220;

  function handleScroll() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var doc = document.documentElement;

    var viewportH = window.innerHeight || doc.clientHeight;
    var docH = Math.max(doc.scrollHeight, doc.offsetHeight);

    // Restlicher Abstand bis zum Seitenende
    var remaining = docH - (scrollTop + viewportH);

    var shouldShow = scrollTop > 0 && remaining > hideBeforeBottom;
    btn.classList.toggle('is-visible', shouldShow);
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll);
  handleScroll();
});

  } catch(e) { console.error(e); }
})();
})();
